import { render, staticRenderFns } from "./BillLogs.vue?vue&type=template&id=5b10abbe&scoped=true"
import script from "./BillLogs.vue?vue&type=script&lang=js"
export * from "./BillLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10abbe",
  null
  
)

export default component.exports